import getPaymentProcessors from '~/utils/balance/getPaymentProcessors'
import type { BackendPaymentProcessorResponse } from '~/types/payment/paymentBackendTypes'
import type { DestinationInterface } from '~/types/destinationTypes'

export default async (
  countries: DestinationInterface[],
  countryId: number,
  depositAmount: number,
  paymentProcessorId: number
) => {
  const allProcessors = await getPaymentProcessors(countries, depositAmount, countryId)

  return allProcessors.find((processor: BackendPaymentProcessorResponse) => processor.id === paymentProcessorId)
}
